// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ox96_","buttons":"styles_buttons__3nX2d"};